export default __webpack_public_path__ + "static/media/ProductsList_img2_Cn.3b3f16b3.webp";